export class GuestAddress {
  countryCode: string;
  stateCode: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  postalCode: string;
  city: string;
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/guest/guest-address.model.ts